export default "__VITE_ASSET__Cqp_CQ9a__"